module.exports = __webpack_public_path__ + "static/media/fruit_jesus_2.f142a4c1.jpeg";